
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FeatureFlagsQuery"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureFlags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coins"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"revolving"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"promocode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"referral"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"historyData"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"affiliateCashback"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"insurance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receipt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reward"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"moneyback"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"investment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"wheelOfFortune"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"payInThreeSanction"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"registration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"segmentation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"validatorSetRestart"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rtaAuthorization"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"upsellServices"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bankIdIntegration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"jarabot"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bnplLimitsMinimal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bnplLimitsMaximal"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":391}};
    doc.loc.source = {"body":"query FeatureFlagsQuery {\n\tfeatureFlags {\n\t\tinstallments\n\t\tcoins\n\t\trevolving\n\t\tpromocode\n\t\treferral\n\t\thistoryData\n\t\taffiliateCashback\n\t\tinsurance\n\t\treceipt\n\t\treward\n\t\tmoneyback\n\t\tinvestment\n\t\twheelOfFortune\n\t\tpayInThreeSanction\n\t\tregistration\n\t\tsegmentation\n\t\tvalidatorSetRestart\n\t\trtaAuthorization\n\t\tupsellServices\n\t\tbankIdIntegration\n\t\tjarabot\n\t\tbnplLimitsMinimal\n\t\tbnplLimitsMaximal\n\t}\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["FeatureFlagsQuery"] = oneQuery(doc, "FeatureFlagsQuery");
        
